import { render } from "./editarCompania.vue?vue&type=template&id=036f2618&scoped=true"
import script from "./editarCompania.vue?vue&type=script&lang=js"
export * from "./editarCompania.vue?vue&type=script&lang=js"

import "./editarCompania.vue?vue&type=style&index=0&id=036f2618&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036f2618"]])

export default __exports__